import { render, staticRenderFns } from "./aside-panel.vue?vue&type=template&id=adfad86c&scoped=true"
import script from "./aside-panel.vue?vue&type=script&lang=js"
export * from "./aside-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfad86c",
  null
  
)

export default component.exports